import {
  SET_ACCESS_TOKEN,
  SET_MY_INFO,
  DESTROY_ACCESS_TOKEN,
  DESTROY_MY_INFO,
  SET_KAKAO_ACCOUNT,
  DESTROY_KAKAO_ACCOUNT
} from "./mutations-types";
import api from "@/api";
const moment = require("moment");
import Cookies from "js-cookie";

export default {
  //로그인
  async signIn({ commit, dispatch }, payload) {
    commit(DESTROY_MY_INFO);
    commit(DESTROY_ACCESS_TOKEN);

    const { userAgent, loginId, password } = payload;
    try {
      const res = await api.post("/authenticate", { userAgent, loginId, password });

      const { token } = res.data;
      commit(SET_ACCESS_TOKEN, token);

      // 관리자 로그인 시도시 -> admin role확인
      // if (payload.userType === "admin") {
      //   const authorities = res.data.authorities;
      //   var itemIdx = authorities.map(x => x.authorityName).indexOf("ROLE_ADMIN");
      //   if (itemIdx < 0) {
      //     Vue.$toast.open({
      //       message: '관리자 권한이 없습니다.',
      //       type: 'error',
      //       duration: 3000,
      //       dismissible: true
      //     });
      //     return;
      //   }
      // }

      // 로그인 ip/시간 저장
      const accessInfo = {
        user_id: res.data.user_id,
        cell: res.data.cell,
        loginUserName: res.data.username,
        loginUserId: res.data.loginId,
        loginUserType: res.data.userType,
        loginUserSignupPath: res.data.signupPath,
        ip: res.data.loginIp,
        recentLoginDate: res.data.recentLoginDate
      }
      const CookieName = process.env.VUE_APP_CookieName;
      Cookies.set(CookieName, JSON.stringify(accessInfo), { expires: 100000 });

      return res.data;
    } catch (err) {
      if (err.response.status === 401) {
        return err.response.status;
      } else {
        return alert("Login Error");
      }
    }
  },

  //토큰이 있는 경우 내정보 가져오기
  async signinByToken({ commit, dispatch }, token) {
    console.log('savedToken', token);

    commit(DESTROY_MY_INFO);
    commit(SET_ACCESS_TOKEN, token);

    try {
      if (token) {
        dispatch("getMeInfo");
      } else {
        this.$router.push({ name: "SignUpPage" });
      }
    } catch (err) {
      if (err.response.status === 500) {
        dispatch("signout");
      }
    }
  },

  async getMeInfo({ commit, dispatch }) {
    try {
      const res = await api.get("/user/me");
      if (res) {
        return commit(SET_MY_INFO, res.data);
      }
    } catch (err) {
      if (err.response.status === 500) {
        dispatch("signOut");
      } else {
        return alert("me error");
      }
    }
  },

  //로그아웃
  signOut({ commit }) {
    commit(DESTROY_MY_INFO);
    commit(DESTROY_ACCESS_TOKEN);
  },

  setKakaoAccount({ commit }, payload) {
    commit(SET_KAKAO_ACCOUNT, payload);
  },

  clearKakaoAccount({ commit }, payload) {
    commit(DESTROY_KAKAO_ACCOUNT);
  },

  // 회원탈퇴
  async withdrawalUser({ commit }, payload) {
    try {
      const { user_id, loginId, selectedSurvey } = payload;
      const res = await api.post(`/admin/user/withdrawal`, { user_id, loginId, selectedSurvey });
      if (res) {
        return res.data;
      }
    } catch (err) {
      return alert("withdrawal error");
    }
  },

  //회원가입
  // async signup({ commit }, payload) {
  //   commit(DESTROY_MY_INFO);
  //   commit(DESTROY_ACCESS_TOKEN);

  //   const { userId, password, name, type, mobile, gender, agree } = payload.userData;

  //   try {
  //     const res = await api.post("/users/signup", { userId, password, name, type, mobile, gender, agree });
  //     if (res) {
  //       alert("회원가입 성공");
  //     }
  //   } catch (err) {
  //     if (err.response.status === 409) {
  //       return alert(err.response.data.message);
  //     } else {
  //       return alert("회원가입 에러");
  //     }
  //   }
  // },
}